/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Account created — password shown once, store it securely.
 * @export
 * @interface CreateApiAccount201Response
 */
export interface CreateApiAccount201Response {
    /**
     * UUID of the newly created API account.
     */
    accountId: string;
    /**
     * Username for authentication.
     */
    username: string;
    /**
     * Initial password — returned only once. Store it securely.
     */
    password: string;
}

/**
 * Check if a given object implements the CreateApiAccount201Response interface.
 */
export function instanceOfCreateApiAccount201Response(value: object): value is CreateApiAccount201Response {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function CreateApiAccount201ResponseFromJSON(json: any): CreateApiAccount201Response {
    return CreateApiAccount201ResponseFromJSONTyped(json, false);
}

export function CreateApiAccount201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiAccount201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'username': json['username'],
        'password': json['password'],
    };
}

export function CreateApiAccount201ResponseToJSON(json: any): CreateApiAccount201Response {
    return CreateApiAccount201ResponseToJSONTyped(json, false);
}

export function CreateApiAccount201ResponseToJSONTyped(value?: CreateApiAccount201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'username': value['username'],
        'password': value['password'],
    };
}

